import styled from 'styled-components';

export const ButtonWrapper = styled.button`
  display: flex;
  padding: 2px;
  align-items: flex-start;
  gap: 2px;
  text-decoration-line: underline;
  border: none;
  background-color: transparent;
`;

export const MobileFilterItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
